import React, { useState, useEffect } from 'react';
import API from '../api';
import { useNavigate } from 'react-router-dom';
import './css/login.css';
import logo from '../assets/merchant-marvels.jpg';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../store/authSlice';

function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Ensure Axios sends/receives the HTTP-only cookie
  useEffect(() => {
    API.defaults.withCredentials = true;
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = form;

    if (!email.trim() || !password.trim()) {
      setError('Email and password are required.');
      return;
    }

    try {
      setLoading(true);
      const { data } = await API.post('/auth/login', { email, password });

      // Server sets an HttpOnly cookie; response body contains the user object.
      const user = data?.user;
      if (!user) {
        throw new Error('Unexpected response from server.');
      }

      // Keep payload shape compatible with existing reducer (token now null/unused).
      dispatch(loginSuccess({ token: null, user }));

      // Do NOT set Authorization header — cookie is used for auth.
      navigate('/leads');
    } catch (err) {
      const message =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        'Login failed. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mm-login-container">
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>WELCOME TO MERCHANT MARVELS</h1>
          <p>Join our community of thousands and unlock exclusive insights daily</p>
        </div>
      </div>

      <div className="mm-login-right">
        <img src={logo} alt="Merchant Marvels Logo" className="mm-login-logo" />
        <form onSubmit={handleSubmit} className="mm-login-form">
          <h2 className="mm-login-title">Login</h2>
          <p className="mm-login-subtitle">Enter your credentials to continue</p>

          {error && <div className="mm-error-message" role="alert">{error}</div>}

          <input
            className="mm-login-input"
            name="email"
            type="email"
            placeholder="Enter Email Address"
            value={form.email}
            onChange={handleChange}
            autoComplete="email"
            required
          />
          <input
            className="mm-login-input"
            name="password"
            type="password"
            placeholder="Enter Password"
            value={form.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />

          <button className="mm-login-button" type="submit" disabled={loading}>
            {loading ? 'Logging in…' : 'LOGIN'}
          </button>

          <div id="googleSignInDiv" style={{ marginTop: '20px', width: '100%' }}></div>

          <p className="mm-login-footer">
          Forget Password? <a href="/forgot-password">Reset here</a>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;
